<template>
  <div class="detial-cont-view">
    <a-descriptions layout="vertical">
      <a-descriptions-item label="审计机构">
        <a-input
          class="w300"
          placeholder="请输入审计机构"
          v-model="form.collectionName"
          :disabled="disabled"
          @change="changeEmitFn"
        />
      </a-descriptions-item>
      <a-descriptions-item label="被审计单位">
        <a-input
          class="w300"
          placeholder="请输入被审计单位"
          v-model="form.collectionName"
          :disabled="disabled"
          @change="changeEmitFn"
        />
      </a-descriptions-item>
      <a-descriptions-item label="审计报告文号">
        <a-input
          class="w300"
          placeholder="请输入审计报告文号"
          v-model="form.collectionName"
          :disabled="disabled"
          @change="changeEmitFn"
        />
      </a-descriptions-item>
      <a-descriptions-item label="审计类型">
        <a-select
          class="w300"
          placeholder="请选择审计类型"
          v-model="form.type"
          :disabled="disabled"
        >
          <template v-for="(item, index) in bytype.options">
            <a-select-option :value="item.valuename" :key="index">{{
              item.keyname
            }}</a-select-option>
          </template>
        </a-select>
      </a-descriptions-item>
      <a-descriptions-item label="审计报告时间" v-if="otherPayway">
        <a-date-picker
          allowClear
          class="w300"
          v-model="form.applyTime"
          valueFormat="YYYY-MM-DD"
          :disabled="disabled"
        />
      </a-descriptions-item>
      <a-descriptions-item label="涉密程度">
        <a-select
          class="w300"
          placeholder="请选择涉密程度"
          v-model="form.type"
          :disabled="disabled"
        >
          <a-select-option value="0"> 涉密 </a-select-option>
          <a-select-option value="1"> 非涉密 </a-select-option>
        </a-select>
      </a-descriptions-item>
      <a-descriptions-item label="备注">
        <a-input
          class="w300"
          placeholder="请添加"
          v-model="form.remark"
          :disabled="disabled"
        />
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  props: ['disabled', 'resDetail', 'formInfo'],
  model: {
    event: 'input',
    prop: 'formInfo'
  },
  data() {
    return {
      form: {
        collectionName: '',
        type: [],
        applyTime: [],
        remark: ''
      },
      options: [],
      organizationIds: [],
      totalFeeCapitalize: '',
      otherPayway: false
    }
  },
  watch: {
    resDetail(val) {
      this.form = val
    }
  },
  computed: {
    ...mapState(['app', 'bytype'])
  },
  created() {},
  mounted() {
    if (this.resDetail) {
      this.form = this.resDetail
    }
  },
  methods: {
    ...mapActions(['getorganizeListFn', 'getpaymentwayVal']),
    changeEmitFn() {}
  }
}
</script>
<style lang="scss" scoped>
.detial-cont-view {
  background: #fff;
  padding: 30px;
  .accessory-btn {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/standingBook/components/form.vue